/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Table_TitleInputs */

const en_pc_alt_table_title = /** @type {(inputs: Pc_Alt_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft and its alternatives, side by side`)
};

const zh_pc_alt_table_title = /** @type {(inputs: Pc_Alt_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 与替代方案并列对比`)
};

/**
* | output |
* | --- |
* | "PdfCraft and its alternatives, side by side" |
*
* @param {Pc_Alt_Table_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_table_title = /** @type {((inputs?: Pc_Alt_Table_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Table_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_table_title(inputs)
	return zh_pc_alt_table_title(inputs)
});
export { pc_alt_table_title as "pc.alt.table_title" }